import { NavLink } from 'react-router-dom';

/**
 * The athlete's bottom bar (ruled 16 October, Athlete Portal canvas row 6; ruled
 * 1 November: no Messages). Lessons is the athlete's own list at /my. Upload
 * lives on the lesson page, not here.
 */
const ITEMS = [
  { to: '/', label: 'Home', end: true },
  { to: '/tools', label: 'Tools', end: false },
  { to: '/my', label: 'Lessons', end: false },
  { to: '/account', label: 'Account', end: false },
] as const;

export function AthleteNav() {
  return (
    <nav className="app-nav" aria-label="Primary">
      {ITEMS.map((item) => (
        <NavLink key={item.to} to={item.to} end={item.end}>
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
